<template>
  <div class="loginindex1">
    <img class="logo" src="../assets/loginlogo.png" />
    <div class="logotitle">猎头互助平台 / 猎头好帮手 / 找好猎头上聘快快</div>
    <div class="rightbox">
      <div class="logoBody">
        <div class="statusbox" v-if="loginStatus">
          <p class='qrtext1'>登录中.....</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Config from "../config/index";
import { setInterval } from "timers";
import moment from 'moment';
let QRCode = require("qrcode");
export default {
  name: "loginRe",
  props: {},
  data() {
    return {
      uuid: "",
      qrUrl: "",
      qrloading: false,
      loginZt: "hr",
      compLoading: false,
      companyEmail: "",
      companyPassword: "",
      loginStatus: true,
      code: "",
      userInfo: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      phone: ""
    };
  },
  watch: {},
  created: function () { },
  methods: {
    getUrlParams: function (url) {
      let urlStr = url.split('?')[1]
      let obj = {};
      let paramsArr = urlStr.split('&')
      for (let i = 0, len = paramsArr.length; i < len; i++) {
        let arr = paramsArr[i].split('=')
        obj[arr[0]] = arr[1];
      }
      return obj
    },
    goLogin: function () {
      let that = this;
      let url = Config.path + "/api/common/auth/web/login";
      axios({
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json"
        },
        data: {
          "code": this.code,
          "loginType": "1"
        }
      })
        .then(function (response) {
          console.log(response);
          

          if (response.data.success === "1") {
            let data = response.data.content
            that.$store.commit("setUser", data);
            console.log(that.$store.state);
            localStorage.setItem("token", data.token);
            localStorage.setItem("nickname", data.nickname);
            localStorage.setItem("avatarPath", data.avatarPath);
            that.$notify({
              title: "提示",
              message: "登录成功",
              type: "success",
              duration: 1000
            });
            that.$router.push({
              path: "/"
            });
          } else {
            that.$message({
              message: response.data.message,
              type: "warning"
            });
          }
        })
        .catch(function (error) {
          that.loading = false;
          console.log(error);
        });
    }
  },
  mounted: function () {
    let u = window.location.href
    let obj = this.getUrlParams(u)
    let code = obj.code
    this.code = code
    this.goLogin()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.loginindex1 {
  min-width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-image: url('../assets/loginbg.png');
  background-position: center top;
  background-size: 100% auto;
  background-repeat: no-repeat;
  min-height: 100vh;

  .logo {
    width: 216.5px;
    height: 67.8px;
    margin: 103px auto 0 auto;
  }

  .logotitle {
    color: #ffffff;
    font-size: 18px;
    font-weight: 290;
    line-height: 24px;
    margin-top: 37.6px;
  }

  .statusbox {
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;
  }

  .actionbtn {
    color: #000000;
    padding-top: 20px;
    text-align: center;
  }

  .qrcont {
    margin: 20px auto 0 auto;
    width: 300px;
    height: 300px;
    background-size: 100%, 100%;
  }

  .sumbitBtn {
    width: 100%;
    background: #5cc2cf;
    display: block;
    margin: 0 auto;
  }

  .qrtext1 {
    color: #5cc2cf;
    padding-top: 60px;
    text-align: center;
    padding-bottom: 60px;
  }

  .qrtext2 {
    color: #5cc2cf;
    padding-top: 30px;
    text-align: left;
  }

  .qrtext3 {
    color: #5cc2cf;
    padding-top: 60px;
    padding-bottom: 50px;
    text-align: center;
  }

  .qrtext {
    color: #5cc2cf;
    padding-top: 20px;
    text-align: center;
  }

  .el-tab-pane {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .el-tabs__item {
    color: #ffffff;
  }

  .pkkQrfd {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 150px;
    background-color: transparent;
    border-radius: 8px;
    padding: 20px;
    position: fixed;
    right: 30px;
    bottom: 30px;

    img {
      width: 129px;
      border-radius: 100%;
      padding: 10px;
    }

    p {
      color: #ffffff;
      text-align: center;
      font-size: 12px;
      padding-top: 20px;
    }
  }

  .rightbox {
    width: 410px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 23px;

    .logoBody {
      width: 410px;
      position: relative;
      background-color: #ffffff;
      border-radius: 10px;

      .qrbtn {
        position: absolute;
        right: 5px;
        bottom: 5px;
        width: 100px;
        height: 100px;
      }
    }
  }
}
</style>
